import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { SearchSubRuleEditorData } from '../../state/SearchManagerV2/SubRuleEditorData';
import { SearchSubRuleBulkEditorData } from '../../state/SearchManagerV2/SubRuleBulkEditorData';

const updateSearchSubRuleBulkEditorData: Reducer<SearchSubRuleBulkEditorData> = (
  state: SearchSubRuleBulkEditorData = new SearchSubRuleBulkEditorData(),
  action: Action<ActionType, SearchSubRuleEditorData>
) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_RESET:
      return new SearchSubRuleBulkEditorData();
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_SAVED:
      return { ...state, searchSubRuleEditBulkResponse: action.data, readyToSave: false };
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_UPDATED:
      let result = {
        ...state,
        editorData: {
          ...state.editorData,
          ...action.data,
        },
      };
      return result;
    default:
      return state;
  }
};

export default updateSearchSubRuleBulkEditorData;
